import apis from './apis';

export const fetchCountries = (query, options) =>
  apis.get('references/countries', {
    query,
    options,
  });

export const fetchNetworks = (query, options) =>
  apis.get('references/networks', {
    params: query,
    options,
  });

export const fetchNetworkPrice = (
  { busZone, networkCode, countryCode },
  options
) =>
  apis.get('references/prices', {
    params: { busZone, networkCode, countryCode },
    options,
  });

export const fetchPricesByCountry = (countryCode, busZone, options) =>
  apis.get(`references/pricesByCountry/`, {
    params: { busZone, countryCode },
    options,
  });

export const fetchExportReasons = (query, options) =>
  apis.get('references/exportReasons', {
    params: query,
    options,
  });

export const fetchNiRequiredFields = (query, options) =>
  apis.get('references/requiredFieldsForDomesticZone', {
    params: query,
    options,
  });

export const fetchServicePrices = (query, options) =>
  apis.get('references/service/prices', {
    params: query,
    options,
  });
